const TRACKING_BASE_URL = "https://tracking.shipinsure.io/tracking";

export function getTrackingUrl(shipInsureId) {
  if (!shipInsureId) {
    return null;
  }

  return `${TRACKING_BASE_URL}/${encodeURIComponent(shipInsureId)}`;
}
